module.exports = __webpack_public_path__ + "img/5104cb9.jpg";